import React from "react";

import clsx from "clsx";

import { useUser } from "@components/user-context";
import { type Annotation } from "@features/custom-annotations";
import { type User } from "@internal/user";
import { SecondaryButton } from "@shared/buttons";

interface AnnotationEditProps {
  annotation: Annotation;
  editAnnotation: (annotation: Annotation) => void;
}

const ownedByUserOrAdmin = (user: User, annotation: Annotation) => {
  return user.authedUserId === annotation.userId || user.isAdmin;
};

export const AnnotationEdit = ({
  annotation,
  editAnnotation,
}: AnnotationEditProps) => {
  const { user } = useUser();

  if (!ownedByUserOrAdmin(user, annotation)) {
    return null;
  }

  return (
    <SecondaryButton
      className={clsx(
        "m-0 p-0 w-7 h-7 flex items-center justify-center border-0",
        "hover:bg-cosmic group/button opacity-0 group-hover/edit:opacity-100",
      )}
      data-testid="edit-annotation"
      onClick={() => editAnnotation(annotation)}
    >
      <i className="fa-regular fa-pen text-primary group-hover/button:text-white" />
    </SecondaryButton>
  );
};
